/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRecoveringProductDto } from '../../models/create-recovering-product-dto';
import { RecoveringProduct } from '../../models/recovering-product';

export interface CreateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params {
      body: CreateRecoveringProductDto
}

export function createOneBaseMgmtRecoveringProductControllerRecoveringProduct(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProduct>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtRecoveringProductControllerRecoveringProduct.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringProduct>;
    })
  );
}

createOneBaseMgmtRecoveringProductControllerRecoveringProduct.PATH = '/api/mgmt/recovering-product';
